import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    margin: '0 13px',
  },
  yellowText: {
    color: theme.palette.yellow.color,
  },
  firstColumn: {
    paddingLeft: 0
  },
}))
